<ion-content>
  <div class="header-block">
    <div class="title">
      <span>{{type | translate}}</span>
    </div>
    <div class="right-block">
      <ion-searchbar mode='ios' [(ngModel)]="searchTerm" [showCancelButton]="'never'" (ionChange)="getItems($event)">
      </ion-searchbar>
      <ng-select
        [ngModel]="selectedLanguageCode"
        (ngModelChange)="onLanguageChange($event)"
        [items]="languageOptions"
        bindLabel="display"
        bindValue="code"
        [clearable]="false"
        appendTo="body"
        placeholder="{{ 'Select Language' | translate }}"
        class="type-dropdown pick-hazard-language-select">
      </ng-select>
      <ng-container *ngIf="type === PickType.PICK_MEASURE">
        <ng-select
          [(ngModel)]="measureType"
          (ngModelChange)="onMeasureTypeChange($event)"
          [items]="sharedValue?.measureTypes"
          bindLabel="label"
          placeholder="{{ 'Select Type Of Measure' | translate }}"
          class="type-dropdown"
        >
          <ng-template ng-label-tmp let-type="item">
            {{ getMeasureTypeTranslationKey(type.measure_type_name) | translate }}
          </ng-template>
          <ng-template ng-option-tmp let-type="item">
            {{ getMeasureTypeTranslationKey(type.measure_type_name) | translate }}
          </ng-template>
        </ng-select>
      </ng-container>
      <div class="close-icon" (click)="close()">
        <img keyboardCloseIcon tooltip="{{'Close' | translate }}" alt="" placement="bottom" src="/assets/icon/cancel.svg">
      </div>
    </div>
  </div>

  <div tabindex="-1" class="search-results" [class.search-results--empty]="showEmptyState" #infScroller infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="1000"
    (scrolled)="onScroll()" [scrollWindow]="false" [immediateCheck]="true" [alwaysCallback]="true">
    <p *ngIf="showEmptyState" class="empty-state" role="status">
      {{ (type === PickType.PICK_MEASURE ? 'no_measures_found' : 'no_initial_hazard_found') | translate }}
    </p>
    <ion-radio-group *ngIf="!showEmptyState" [(ngModel)]="selectedData" role="radiogroup">

      <section class="suggested" *ngIf="showGenerated">
        <header class="group-head">
          <svg class="group-mark" viewBox="0 0 24 24" aria-hidden="true">
            <defs>
              <linearGradient id="generatedMark" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#FE4649"/>
                <stop offset="0.4" stop-color="#CD5CC2"/>
                <stop offset="0.7" stop-color="#8B68EF"/>
                <stop offset="1" stop-color="#3E96FE"/>
              </linearGradient>
            </defs>
            <path d="M12 2.2c.6 5.2 4.6 9.2 9.8 9.8-5.2.6-9.2 4.6-9.8 9.8-.6-5.2-4.6-9.2-9.8-9.8 5.2-.6 9.2-4.6 9.8-9.8z" fill="url(#generatedMark)"/>
          </svg>
          <span class="group-label group-label--ai">{{ 'ai_recommended' | translate }}</span>
          <ion-spinner *ngIf="generatedLoading" name="dots"></ion-spinner>
          <button type="button" class="suggested-toggle" (click)="toggleGenerated()"
            [attr.aria-expanded]="!generatedCollapsed">
            {{ (generatedCollapsed ? 'Show' : 'Hide') | translate }}
          </button>
        </header>

        <ng-container *ngIf="!generatedCollapsed">
          <p class="group-notice" *ngIf="generatedNotice && !generatedLoading">{{ generatedNotice | translate }}</p>
          <p class="group-notice group-notice--draft" *ngIf="generated.length && !generatedLoading">
            {{ 'ai_generated_measures_verify' | translate }}
          </p>

          <ion-row>
            <ion-col size="4" *ngFor="let measure of generated">
              <ion-card
                (click)="onGeneratedSelect(measure)"
                [ngClass]="{ 'border-style': selectedData === measure }"
                class="radio-card"
                [tooltip]="measure.value"
                role="radio"
                [attr.aria-checked]="selectedData === measure"
                tabindex="0"
                (keydown.enter)="onGeneratedSelect(measure)"
                (keydown.space)="onGeneratedSelect(measure)"
              >
                <div class="radio-card-content">
                  <div class="radio-column">
                    <ion-radio [value]="measure" mode="md" [tabindex]="-1"></ion-radio>
                  </div>
                  <div class="text-column">
                    <p class="card-text">{{ measure.value | ellipsis: 240 }}</p>
                  </div>
                </div>
              </ion-card>
            </ion-col>
          </ion-row>
        </ng-container>
      </section>

      <section class="suggested" *ngIf="showSuggestions">
        <header class="group-head">
          <svg class="group-mark" viewBox="0 0 24 24" aria-hidden="true">
            <defs>
              <linearGradient id="suggestedMark" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#FE4649"/>
                <stop offset="0.4" stop-color="#CD5CC2"/>
                <stop offset="0.7" stop-color="#8B68EF"/>
                <stop offset="1" stop-color="#3E96FE"/>
              </linearGradient>
            </defs>
            <path d="M12 2.2c.6 5.2 4.6 9.2 9.8 9.8-5.2.6-9.2 4.6-9.8 9.8-.6-5.2-4.6-9.2-9.8-9.8 5.2-.6 9.2-4.6 9.8-9.8z" fill="url(#suggestedMark)"/>
          </svg>
          <span class="group-label group-label--ai">{{ 'Suggested for this hazard' | translate }}</span>
          <ion-spinner *ngIf="suggestionsLoading" name="dots"></ion-spinner>
          <button type="button" class="suggested-toggle" (click)="toggleSuggestions()"
            [attr.aria-expanded]="!suggestionsCollapsed">
            {{ (suggestionsCollapsed ? 'Show' : 'Hide') | translate }}
          </button>
        </header>

        <ng-container *ngIf="!suggestionsCollapsed">
          <p class="group-notice" *ngIf="suggestionsNotice && !suggestionsLoading">{{ suggestionsNotice | translate }}</p>

          <div class="suggested-group" *ngFor="let group of suggestionGroups">
            <h3 class="suggested-group-label">{{ getMeasureTypeTranslationKey(group.typeName) | translate }}</h3>
            <ion-row>
              <ion-col size="4" *ngFor="let suggestion of group.items">
                <ion-card
                  (click)="onSuggestionSelect(suggestion)"
                  [ngClass]="{ 'border-style': selectedData === suggestion }"
                  class="radio-card"
                  [tooltip]="suggestion.value"
                  role="radio"
                  [attr.aria-checked]="selectedData === suggestion"
                  tabindex="0"
                  (keydown.enter)="onSuggestionSelect(suggestion)"
                  (keydown.space)="onSuggestionSelect(suggestion)"
                >
                  <div class="radio-card-content">
                    <div class="radio-column">
                      <ion-radio [value]="suggestion" mode="md" [tabindex]="-1"></ion-radio>
                    </div>
                    <div class="text-column">
                      <p class="card-text">{{ suggestion.value | ellipsis: 160 }}</p>
                    </div>
                  </div>
                </ion-card>
              </ion-col>
            </ion-row>
          </div>
        </ng-container>
      </section>

      <header class="group-head group-head--plain" *ngIf="type === PickType.PICK_MEASURE">
        <span class="group-label">{{ 'All measures' | translate }}</span>
      </header>

      <ion-row>
        <ion-col size="4" *ngFor="let each of initialHazardsList; let i = index">
          <ion-card
            (click)="onCardSelect(i)"
            [ngClass]="{ 'border-style': selectedData === each }"
            class="radio-card"
            [tooltip]="each.value"
            role="radio"
            [attr.aria-checked]="selectedData === each"
            [attr.tabindex]="getCardTabIndex(i)"
            (focus)="onCardFocus(i)"
            (keydown)="onCardKeydown($event, i)"
          >
            <div class="radio-card-content">
              <div class="radio-column">
                <ion-radio [value]="each" mode="md" [tabindex]="-1"></ion-radio>
              </div>
              <div class="text-column">
                <p class="card-text">{{ each.value | ellipsis: 160 }}</p>
              </div>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-radio-group>
  </div>
</ion-content>
<ion-footer>
  <ion-row class="button-row">
     <ion-button class="app-btn" shape="round" fill="outline" color="primary"
      (click)="close()">
      {{'Cancel'|translate}}
    </ion-button>
    <ion-button class="app-btn" shape="round" fill="outline" color="primary" [class.disabled]="!selectedData"
      (click)="save()">
      {{'Pick'|translate}}
    </ion-button>
  </ion-row>
</ion-footer>